import BasicResource from '@/api/resource';

class Resource extends BasicResource {

    constructor () {
        super('tracking-links');
    }

    getByOffer (offerId, params) {
        return this.client.request ({
            method: 'get',
            path: `/publisher/v1/tracking-links/offers/${offerId}`,
            params: params,
        });
    }

    download (data) {
        const { sort, limit, offset, ...params } = { ...data };

        return this.client.download ({
            method: 'get',
            path: '/publisher/v1/tracking-links/download',
            params,
        });
    }

    clicktags (id, params) {
        return this.client.request ({
            method: 'get',
            path: `/publisher/v1/tracking-links/${id}/clicktag`,
            params,
        });
    }
}

export default new Resource;
